import { twMerge } from 'tailwind-merge';

import { tw } from '~/utils';

import type { FavoriteIconStyles } from '../utils/favorite-icon';

export const favoriteSlot = tw('flex cursor-pointer gap-1');

const favoriteIconBaseClassName = tw('inline h-[24px] w-[24px] transition hover:scale-110 hover:fill-red-500');

export const favoriteIconStyles = tw<FavoriteIconStyles>({
  on: twMerge(favoriteIconBaseClassName, 'fill-brand text-brand'),
  off: twMerge(favoriteIconBaseClassName, 'text-brand fill-white'),
});
